var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "get-action": _vm.queryApi,
          "query-params": _vm.queryParams,
          "label-width": "80px",
          "col-span": _vm.colSpan,
          "before-reset-search": _vm.beforeResetSearch,
          "cell-class-name": _vm.actualCellClassName,
        },
        on: {
          afterFetchOriginalData: _vm.afterFetchOriginalData,
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("billingPage.yearAndWeek"),
                          prop: "year",
                        },
                      },
                      [
                        _c("el-date-picker", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            id: "getWeekDate",
                            "picker-options": { firstDayOfWeek: 1 },
                            type: "week",
                            format: "yyyy-WW",
                            clearable: false,
                            placeholder: _vm.$t("billingPage.yearAndWeeks"),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.weekDataNow,
                            callback: function ($$v) {
                              _vm.weekDataNow = $$v
                            },
                            expression: "weekDataNow",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("AccountManagement.staff.department"),
                          prop: "department",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            "option-list": _vm.staffDepartmentList,
                            clearable: !_vm.deptDis,
                            placeholder: _vm.$t(
                              "AccountManagement.staff.department"
                            ),
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.department,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "department", $$v)
                            },
                            expression: "queryParams.department",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _vm.havePermission
                      ? _c(
                          "el-button",
                          {
                            staticClass: "main-btn",
                            on: {
                              click: function ($event) {
                                return _vm.importStaffButton()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "AccountManagement.staffLeave.importLeave"
                                )
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.havePermission
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.$refs.staffLeaveDialog.open()
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("AccountManagement.staffLeave.viewLeave")
                              )
                            ),
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        staticClass: "main-btn",
                        attrs: { type: "primary" },
                        on: { click: _vm.onExport },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "weekDay"
                                      ? [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.weekDay) +
                                                " " +
                                                _vm._s(
                                                  _vm.timeFilters(
                                                    scope.row.date
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      : col.prop === "plan"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onPlan(
                                                    scope.row,
                                                    "viewPlan"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.plan))]
                                          ),
                                        ]
                                      : col.prop === "actual"
                                      ? [
                                          _c(
                                            "span",
                                            {
                                              staticClass: "link",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.onActual(
                                                    scope.row,
                                                    "viewActual"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(scope.row.actual))]
                                          ),
                                        ]
                                      : col.prop === "approveStatus"
                                      ? [
                                          scope.row[col.prop] != "超用驳回"
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.DEPT_HOURS_HEADCOUNT_SATATUS.bjGet(
                                                          scope.row[col.prop]
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      scope.row.planOperation,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.DEPT_HOURS_HEADCOUNT_SATATUS.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                        ]
                                      : col.prop === "overtimeApproveStatus"
                                      ? [
                                          scope.row[col.prop] != "加班计划驳回"
                                            ? _c("span", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        _vm.DEPT_HOURS_OVERTIME_SATATUS.bjGet(
                                                          scope.row[col.prop]
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    content:
                                                      scope.row
                                                        .overtimeOperation,
                                                    placement: "top",
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            _vm.DEPT_HOURS_OVERTIME_SATATUS.bjGet(
                                                              scope.row[
                                                                col.prop
                                                              ]
                                                            )
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-warning",
                                                      staticStyle: {
                                                        color: "red",
                                                      },
                                                    }),
                                                  ]),
                                                ]
                                              ),
                                        ]
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || "right",
                            align: "center",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (props) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: {
                                          disabled:
                                            [
                                              "计划用人审批中",
                                              "实际用人待申报",
                                              "已完成",
                                            ].includes(
                                              props.row.approveStatus
                                            ) || _vm.isWeekendRow(props.row),
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onPlan(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.plan"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: {
                                          disabled:
                                            [
                                              "计划用人待申报",
                                              "计划用人审批中",
                                              "超用驳回",
                                              "已完成",
                                            ].includes(
                                              props.row.approveStatus
                                            ) || _vm.isWeekendRow(props.row),
                                          type: "text",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onActual(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.actual"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onOverTime(props.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.over"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "edit-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.$refs.ReviewDialog.show(
                                              props.row.date
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "AccountManagement.work.review"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ReviewDialog", {
        ref: "ReviewDialog",
        attrs: {
          departments: _vm.staffDepartmentList,
          "department-labels": _vm.staffDeptList,
        },
      }),
      _c("StaffLeaveDialog", { ref: "staffLeaveDialog" }),
      _vm.isShowForm
        ? _c("PlanForm", { ref: "PlanForm", on: { reFresh: _vm.reFresh } })
        : _vm._e(),
      _vm.isShowForm
        ? _c("ActualForm", {
            ref: "ActualForm",
            attrs: {
              "staff-role-list": _vm.staffRoleList,
              "staff-dept-list": _vm.staffDeptList,
            },
            on: { reFresh: _vm.onTimesheetChanged },
          })
        : _vm._e(),
      _vm.isShowForm
        ? _c("OverTimeForm", {
            ref: "OverTimeForm",
            attrs: {
              "staff-role-list": _vm.staffRoleList,
              "staff-dept-list": _vm.staffDeptList,
            },
            on: { reFresh: _vm.onTimesheetChanged },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          staticClass: "export-timesheet-dialog",
          attrs: {
            title: _vm.$t("AccountManagement.work.exportTimesheetReport"),
            visible: _vm.exportDialogVisible,
            width: "720px",
            "before-close": _vm.handleExportClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.exportDialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "exportForm",
              staticClass: "export-timesheet-form",
              attrs: {
                model: _vm.exportForm,
                rules: _vm.exportRules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "export-employee-type-item",
                  attrs: {
                    label: _vm.$t("AccountManagement.work.employeeType"),
                    prop: "employeeType",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "export-employee-type",
                      on: { change: _vm.handleExportEmployeeTypeChange },
                      model: {
                        value: _vm.exportForm.employeeType,
                        callback: function ($$v) {
                          _vm.$set(_vm.exportForm, "employeeType", $$v)
                        },
                        expression: "exportForm.employeeType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "fullTime" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("AccountManagement.work.fullTimeBiWeekly")
                          )
                        ),
                      ]),
                      _c("el-radio", { attrs: { label: "casual" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("AccountManagement.work.casualWeekly"))
                        ),
                      ]),
                      _c("el-radio", { attrs: { label: "labour" } }, [
                        _vm._v(
                          _vm._s(_vm.$t("AccountManagement.work.labourHire"))
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("AccountManagement.work.period"),
                    prop: "period",
                  },
                },
                [
                  _c("BjSelectLov", {
                    staticClass: "export-period-select",
                    attrs: {
                      "option-list": _vm.currentExportPeriodOptions,
                      placeholder: _vm.$t(
                        "AccountManagement.work.pleaseSelect"
                      ),
                    },
                    model: {
                      value: _vm.exportForm.period,
                      callback: function ($$v) {
                        _vm.$set(_vm.exportForm, "period", $$v)
                      },
                      expression: "exportForm.period",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleExportClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleExportConfirm },
                },
                [_vm._v(_vm._s(_vm.$t("exportText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("AccountManagement.staffLeave.importLeave"),
            visible: _vm.importDialogVisible,
            width: "600px",
            "close-on-click-modal": false,
            "before-close": _vm.handleImportStaffClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.importDialogVisible = $event
            },
            closed: _vm.resetImportStaffDialog,
          },
        },
        [
          _c(
            "el-upload",
            {
              ref: "importStaffUpload",
              staticClass: "import-staff-upload",
              attrs: {
                drag: "",
                action: "",
                accept: ".xls,.xlsx",
                limit: 1,
                "file-list": _vm.importStaffFileList,
                "auto-upload": false,
                "show-file-list": false,
                "on-change": _vm.handleImportStaffFileChange,
                "on-exceed": _vm.handleImportStaffFileExceed,
              },
            },
            [
              _c("i", { staticClass: "el-icon-upload" }),
              _c("div", { staticClass: "el-upload__text" }, [
                _vm._v(_vm._s(_vm.$t("UploadMainText1"))),
                _c("em", [_vm._v(_vm._s(_vm.$t("UploadMainText2")))]),
              ]),
            ]
          ),
          _vm.importStaffFile
            ? _c("div", { staticClass: "import-staff-file-row" }, [
                _c(
                  "div",
                  { staticClass: "import-staff-file-name" },
                  [
                    _c("i", { staticClass: "el-icon-document" }),
                    _c("span", [_vm._v(_vm._s(_vm.importStaffFile.name))]),
                    _c("el-button", {
                      attrs: {
                        type: "text",
                        icon: "el-icon-close",
                        disabled: _vm.importing,
                      },
                      on: { click: _vm.clearImportStaffFile },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.importing },
                  on: { click: _vm.handleImportStaffClose },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.importing },
                  on: { click: _vm.confirmImportStaff },
                },
                [_vm._v(_vm._s(_vm.$t("ConfirmImportText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }